/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-useless-path-segments */
import { Edit, Eye, Link1, Location, MoneyRecive } from 'iconsax-react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from 'styled-components';
import whatsapp from '../../../../assets/images/whatsapp.svg.svg';
import Text from '../../../../assets/styles/Text';
import Loader from '../../../../components/Loader';
import Review from '../../../../components/Review';
import {
  useModelAllReviews,
  useModelFindAboutsSection,
  useModelInfo,
} from '../../../../hooks/queries/useModels';
import { useStore } from '../../../../stores';
import formatPhone from '../../../../utils/formatPhone';
import * as styles from './styles';

export default function Infos({ show }) {
  const [reviewFilter, setReviewFilter] = useState('');

  const theme = useTheme();

  const id = useStore((state) => state.user?.id);

  const { data: model, isLoading: loading } = useModelInfo(id);

  const { data: aboutData, isLoading: isLoadingAbout } =
    useModelFindAboutsSection(id, 'ABOUT');

  const { data: treatmentData, isLoading: isLoadingTreatment } =
    useModelFindAboutsSection(id, 'TREATMENT');

  const {
    data: reviews,
    isLoading: loadingReviews,
    isFetching: reloadReviews,
  } = useModelAllReviews(id, reviewFilter ? { status: reviewFilter } : {});

  const links = [
    {
      text: 'Editar Informações',
      url: '/modeldescription',
      icon: <Edit />,
      id: 1,
    },
    {
      text: 'Editar Valores',
      url: '/modelvalue',
      icon: <MoneyRecive />,
      id: 2,
    },
  ];

  function chooseColorsReview(filter) {
    switch (filter) {
      case 'approved':
        return theme.colors.outher.success;
      case 'denied':
        return theme.colors.outher.danger;
      default:
        return theme.colors.outher.attencion;
    }
  }

  function renderInfos(about, round = false) {
    const half = Math.ceil(about.length / 2);

    const contentHalf = round ? about.slice(0, half) : about.slice(half);

    const formatContent = (content) => content.replace(/,(?!\s)/g, ', ');

    return (
      <ul className={!round && 'this-list'}>
        {contentHalf.map((fil) => (
          <li key={fil.content}>
            <Text.Span>
              <b>{fil.name}:</b>
              {formatContent(fil.content)}
            </Text.Span>
          </li>
        ))}
      </ul>
    );
  }

  const isEmpty = !model?.fantasyName || !model?.impactPhrase || !model?.city;

  const reviewsNoEmpty = !loadingReviews && reviews && reviews.length > 0;

  if (loading)
    return (
      <styles.Container $show={show}>
        <Loader isLoading={loading} minimal size={60} />
      </styles.Container>
    );

  return (
    <styles.Container $show={show}>
      {isEmpty && (
        <styles.Empty>
          <Text.H4 $bold>Adicione as informações que estão faltando</Text.H4>
          <Link to="/modeldescription">Adicionar informações restantes</Link>
        </styles.Empty>
      )}

      {!isEmpty && (
        <styles.GroupRow>
          <styles.GroupInfos>
            <styles.TopInfos>
              <div className="text-status">
                <Text.H3 $bold>{model?.fantasyName}</Text.H3>
              </div>

              <styles.TopInfosGroup>
                <Text.P $bold>{model?._count?.followers} seguidores</Text.P>
                <Text.P $bold>{model?.totalLikes} Curtidas</Text.P>
              </styles.TopInfosGroup>
            </styles.TopInfos>

            <styles.DescriptionInfos>
              <Text.P>{model?.impactPhrase}</Text.P>
            </styles.DescriptionInfos>

            <styles.BottomInfos>
              <styles.PrinceInfos>
                <div>
                  <Text.Span>A partir de:</Text.Span>
                  <h1>
                    R$
                    {model?.values?.[0]?.customRate}/{' '}
                    {model?.values?.[0]?.value?.name}
                  </h1>
                </div>

                <Text.Span>
                  <Location size={32} />
                  <Text.P $bold>
                    {model?.city?.name} - {model?.city?.stateAc}
                  </Text.P>
                </Text.Span>
              </styles.PrinceInfos>

              <styles.PhoneInfos>
                <Link to="/editphone">
                  <img src={whatsapp} alt="whatsapp" />

                  <div>
                    <Text.Span>
                      Seu número atual{' '}
                      {model?.phone && formatPhone(model?.phone)}
                    </Text.Span>
                    <Text.H4 $bold>Editar número</Text.H4>
                  </div>
                </Link>
              </styles.PhoneInfos>
            </styles.BottomInfos>
          </styles.GroupInfos>

          <styles.GroupCollumn>
            <styles.GroupUl>
              <Text.H3 $bold>Sobre mim:</Text.H3>
              <div>
                {isLoadingAbout ? (
                  <Loader isLoading minimal />
                ) : (
                  <>
                    {renderInfos(aboutData, true)}
                    {renderInfos(aboutData, false)}
                  </>
                )}
              </div>
            </styles.GroupUl>

            <styles.GroupUl>
              <Text.H3 $bold>Atendimento:</Text.H3>
              <div>
                {isLoadingTreatment ? (
                  <Loader isLoading minimal />
                ) : (
                  <>
                    {renderInfos(treatmentData, true)}
                    {renderInfos(treatmentData, false)}
                  </>
                )}
              </div>
            </styles.GroupUl>
          </styles.GroupCollumn>
        </styles.GroupRow>
      )}

      {!isEmpty && (
        <styles.GroupCollumn>
          <styles.GroupLinks>
            <a href={`/model/${id}`} target="_blank" rel="noreferrer">
              <Eye />
              <Text.Span $upper>Veja seu perfil</Text.Span>
            </a>

            {links.map((link) => (
              <Link to={link.url} key={link.id}>
                {link.icon}
                <Text.Span $upper>{link.text}</Text.Span>
              </Link>
            ))}

            <a href={`/model/${id}`} target="_blank" rel="noreferrer">
              <Link1 />
              <Text.Span $upper>Compartilhar</Text.Span>
            </a>
          </styles.GroupLinks>
        </styles.GroupCollumn>
      )}

      <styles.GroupCollumn>
        <styles.FilterButtons $color={chooseColorsReview(reviewFilter)}>
          <button
            type="button"
            className={reviewFilter === '' ? 'active' : ''}
            onClick={() => setReviewFilter('')}
          >
            <Text.Span $bold>Novos</Text.Span>
          </button>

          <button
            type="button"
            className={reviewFilter === 'approved' ? 'active' : ''}
            onClick={() => setReviewFilter('approved')}
          >
            <Text.Span $bold>Aprovados</Text.Span>
          </button>

          <button
            type="button"
            className={reviewFilter === 'denied' ? 'active' : ''}
            onClick={() => setReviewFilter('denied')}
          >
            <Text.Span $bold>Negados</Text.Span>
          </button>
        </styles.FilterButtons>

        <styles.Top $color={chooseColorsReview(reviewFilter)}>
          <Text.H3 $bold>Reviews</Text.H3>

          <Text.Span $bold>{reviews?.length || 0} - Reviews</Text.Span>
        </styles.Top>

        {reviewsNoEmpty
          ? reviews.map((rev) => (
              <Review
                key={rev.id}
                review={rev}
                edit
                colors={chooseColorsReview(reviewFilter)}
              />
            ))
          : !reloadReviews && <Text.H2>Nenhum review encontrado</Text.H2>}

        {(loadingReviews || reloadReviews) && <Loader isLoading minimal />}
      </styles.GroupCollumn>
    </styles.Container>
  );
}

Infos.propTypes = {
  show: PropTypes.bool.isRequired,
};
